export default __webpack_public_path__ + "static/oveu-42b827b71579406634829cee6d287c21.webp";